import { Injectable } from "@angular/core";
import { Constants } from "app/shared/constant/constants";
import { ConstantsKey } from "app/shared/constant/constants-keys";
import { BaseProvider } from "app/shared/helper/http/BaseProvider";
import { LinkCardRequest02Model } from "../models/card.model";

@Injectable()
export class CardService extends BaseProvider {

    ///CARD API 
    getCardDetails() {
        var resourceUrl = "getCardDetails";
        return this.makeGetCall(resourceUrl);
    }

    getCardDetailsEncrypted() {
        var resourceUrl = "b2c/getCardDetails";
        return this.makeGetCall(resourceUrl);
    }

    getManageCardOptions(kitId: string) {
        var resourceUrl = "manageCardOptions?kitId=" + kitId;
        return this.makeGetCall(resourceUrl);
    }

    ///ORDER API
    cartPrepare(cartType) {
        var resourceUrl = "cartPrepare?cartType=" + cartType;
        return this.makePostCall(resourceUrl, {});
    }

    getTripDetails() {
        var resourceUrl = "preOrderDetails";
        return this.makeGetCall(resourceUrl);
    }

    mapTripDetails(request) {
        var resourceUrl = "cartTravel";
        return this.makePutCall(resourceUrl, request);
    }

    getSourceOfFundList() {
        var url = "sourceOfFunds";
        return this.makeGetCall(url);
    }

    getFinanceInstituteList() {
        let url = "tcsLoanProvider";
        return this.makeGetCall(url);
    }

    getAddressesHome() {
        return this.makeGetCall("consumers/address");
    }

    getNearByBranch(latitude = 0.0, longitude = 0.0) {
        var resourceUrl = "nearestBranchToCustomer?latitude=" + latitude + "&longitude=" + longitude;
        return this.makeGetCall(resourceUrl);
    }

    getPaxesList() {
        let consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        let resourceUrl = "consumers/" + consumerId + "/paxes";
        return this.makeGetCall(resourceUrl);
    }

    mapPayerTraveller(request) {
        var resourceUrl = "cartPayer";
        return this.makePutCall(resourceUrl, request);
    }

    cartTotalVersusUploadedDocuments() {
        var resourceUrl = "cartTotalVersusUploadedDocuments";
        return this.makeGetCall(resourceUrl);
    }
    getOrderDocuments(orderId) {
        var resourceUrl = 'doclocker/totalVersusUploadedDocuments?orderId='+orderId;
        return this.makeGetCall(resourceUrl);
      }

    uploadDocument(imageData) {
        return this.makeUploadCall("cartDocument", imageData);
    }
    uploadOrderDocument(imageData) {
        console.log("imageData>>>"+imageData);
        return this.makeUploadCall("doclocker/documents", imageData);
      }
      linkDocument( postParam,  orderId)  {
        var orderURL = 'b2c/orders/' + orderId + "/documents";
        return this.makePostCall(orderURL,postParam);
      }
    getA2FormCart(a2AcceptanceRequest) {
        var resourceUrl = "cartA2"
        return this.makePutCall(resourceUrl, a2AcceptanceRequest);
    }

    getCartToUpdateStepNumber(step) {
        var resourceUrl = "cart";
        if (step == 4) {
            resourceUrl = "cart?stepToComplete=" + step.toString();
        }
        return this.makeGetCall(resourceUrl);
    }

    getBankAccountList() {
        var consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        var resourceUrl = 'bankAccount?consumerId=' + consumerId;
        return this.makeGetCall(resourceUrl);
    }

    getQuotation(requestQuotationModel: any) {
        var resourceUrl = "quotationsV2";
        return this.makePostCall(resourceUrl, requestQuotationModel);
    }
    getQuotationEncrypted(requestQuotationModel: any) {
        var resourceUrl = "b2c/quotationsV2";
        return this.makePostCall(resourceUrl, requestQuotationModel);
    }

    cartItemPost(request) {
        var resourceUrl = "cartItem";
        return this.makePutCall(resourceUrl, request);
    }

    mapBeneficiary(request) {
        var resourceUrl = 'cartBenefeciary';
        return this.makePutCall(resourceUrl, request);
    }

    validateCustomer(request) {
        var resourceUrl = 'b2c/validateCustomer';
        return this.makePostCall(resourceUrl, request);
    }

    validateExpiryDob(request) {
        var resourceUrl = 'validateExpiryDob';
        return this.makePostCall(resourceUrl, request);
    }

    otpRequestForBalanceTransfer(request) {
        var resourceUrl = 'otp';
        return this.makePostCall(resourceUrl, request);
    }
     getOTPINRWallet() {
        var resourceUrl = 'b2c/generateInrWalletOtp';
        return this.makePostCall(resourceUrl,{});
     }
      getINRWalletFormFields() {
        var resourceUrl = 'b2c/inrWalletForm';
        return this.makeGetCall(resourceUrl);
     }
     activateINRWallet(request)  {
            var resourceUrl = 'b2c/activateInrWalletNew';
           return this.makePostCall(resourceUrl,request);
     }

    getCurrencyRateList(currencyCode) {
        var resourceUrl = 'pricing/rateRange?product=' + 'FOREXCARD' + '&currencyCode=' + currencyCode + '&partnerId=' + 'p_wsfxConsumer' + '&sellType=' + 'SELL';
        return this.makeGetCall(resourceUrl);
    }

    getCurrencyConversionRateList(currencyCode, selectedCurrencyCode, amount) {
        var resourceUrl = 'pricing/convertCurrency?partnerId=' + 'p_wsfxConsumer' + '&surrenderingCurrencyCode=' + currencyCode + '&requiredCurrencyCode=' + selectedCurrencyCode + '&surrenderingCurrencyAmount=' + amount + '&conversionType=' + 'WALLET';
        return this.makeGetCall(resourceUrl);
    }

    walletToWalletTransfer(request) {
        var resourceUrl = 'b2c/walletToWalletTransfer';
        return this.makePostCall(resourceUrl, request);
    }

    manageCardUpdate(request) {
        var resourceUrl = 'manageCard';
        return this.makePostCall(resourceUrl, request);
    }

    getRaterangeList(product, currencyCode, sellType, partnerId) {
        var serviceURL = "pricing/rateRangeList?product=" + product + "&currencyCode=" + currencyCode + "&partnerId=" + partnerId + "&sellType=" + sellType;
        return this.makeGetCall(serviceURL);
    }

    getBankAccounts() {
        var url = "bankAccount";
        return this.makeGetCall(url);
    }

    getA2FormAcknowledge() {
        var resourceUrl = 'CartA2OtpInit';
        return this.makePostCall(resourceUrl, {});
    }

    getOrderA2OTP() {
        var resourceUrl = 'order/a2OtpInit';
        return this.makeGetCall(resourceUrl);
      }

    getPaymentMethods() {
        var orderURL = "collectionMethods";
        return this.makeGetCall(orderURL);
    }

    initiatePaymentforCart(request, quotationId) {
        var consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        var resourceUrl = "b2cPayments?consumerId=" + consumerId + "&quotationSnapshotId=" + quotationId;
        return this.makePostCall(resourceUrl, request);
    }

    makePGCall(resourceURL: string) {
        this.addHeader("Content-Type", "application/x-www-form-urlencoded");
        this.addHeader("channel", "web");
        this.addHeader("Accept", "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8");
        window.open(resourceURL, "_self");
        return this.makeGetCall(resourceURL);
    }

    getConvertedAmount(surrenderingCurrencyCode, requiredCurrencyCode, requiredCurrencyAmount,sellType, issuerCode) {
        var resourceUrl = "pricing/convertCurrency?partnerId=p_wsfxConsumer&surrenderingCurrencyCode=" +
            surrenderingCurrencyCode + "&requiredCurrencyCode=" + requiredCurrencyCode + "&surrenderingCurrencyAmount=" + requiredCurrencyAmount+"&sellType=" + sellType+"&issuerCode=" + issuerCode;
        return this.makeGetCall(resourceUrl);
    }

    createOrder(request) {
        var userId = Constants.userId;
        var partnerId = Constants.partnerId;
        var consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        var resourceUrl = "b2c/consumers/" + consumerId + "/orders?userId=" + userId + "&partnerId=" + partnerId;
        return this.makePostCallWitList(resourceUrl, request);
    }

    fetchStatement(startDate, endDate,isSendEmail,currencyCode) {
        var resourceUrl = 'b2c/fetchStatementPdf?fromDate=' + startDate + '&toDate=' + endDate+"&pageNo=0"+ '&sendEmail='+isSendEmail+ (currencyCode != 'All Currencies' ? '&currencyCode='+currencyCode : '');
        return this.makeGetCall(resourceUrl);
    }

    getOTP(request) {
        var resourceUrl = "otp";
        return this.makePostCall(resourceUrl, request);
    }

    changeCardPin(request) {
        var resourceUrl = "b2c/setPin";
        return this.makePostCall(resourceUrl, request);
    }

    getCurrentRate() {
        var resourceUrl = "rates/current?partnerId=p_wsfxConsumer&products=FOREXCARD&isMultiCurrencyCard=true";
        return this.makeGetCall(resourceUrl);
    }

    getCardLimit(currencyCode) {
        var resourceUrl = "b2c/cardLimit?currency="+currencyCode;
        return this.makeGetCall(resourceUrl);
    }

    setCardLimit(request) {
        var resourceUrl = "b2c/cardLimit";
        return this.makePostCall(resourceUrl, request);
    }

    replaceCard(request) {
        var resourceUrl = "replaceCard";
        return this.makePostCall(resourceUrl, request);
    }

    getReloadForm(orderId, cardVendor) {
        var resourceUrl = 'cardApplicationReloadForm/' + orderId+"?cardVendor="+cardVendor;
        return this.makeGetCall(resourceUrl);
    }

    getReloadFormWithOrder(orderId) { 
        var resourceUrl = 'b2c/orders/' + orderId;
        return this.makeGetCall(resourceUrl);
    }

    getA2Form(otp, request) {
        var resourceUrl = "cartA2?otp=" + otp;
        return this.makePutCall(resourceUrl, request);
    }

    validateA2OTP(orderConsumerA2AcceptanceRequest) {
        var resourceUrl = "order/generateA2Signed";
        return this.makePostCall(resourceUrl, orderConsumerA2AcceptanceRequest);
    }

    getCardLinkOTP(isResend, request) {
        let resourceUrl = "validateMobileCustomer?resend=" + isResend;
        return this.makePostCall(resourceUrl, request);
    }

    cardLinkStep02(linkCardModel02: LinkCardRequest02Model) {
        var resourceUrl = "validateExpiryDob";
        return this.makePostCall(resourceUrl, linkCardModel02);
    }

    getDueDelligenceStatus(countryCode) {
        var resourceUrl = 'getCartCountriesSanctionsStatus?countryCode=' + countryCode;
        return this.makeGetCall(resourceUrl);
    }

    getINRWalletOTP() {
        var resourceUrl = "generateInrWalletOtp";
        return this.makePostCall(resourceUrl, {});
    }

    validateActiveINRWalletOTP(otpValue) {
        var resourceUrl = "activateInrWallet?otp=" + otpValue;
        return this.makePostCall(resourceUrl, {});
    }

    temporaryBlockCard(request) {
        var resourceUrl = "manageCard";
        return this.makePostCall(resourceUrl, request);
    }

    getEncashmentOTP(request) {
        return this.makePostCall('cartEncashmentOtpInit', request);
    }

    validateEncashmentOTP(otp, request) {
        var orderURL = 'cartEncashment?otp=' + otp;
        return this.makePutCall(orderURL, request);
    }
    
    getEncashmentForm(bankId, paxId, quotationSnapshotId, cardVendor, orderId) {
        var resourceURL = 'getEncashmentForm?bankId=' + bankId + '&paxId=' + paxId + '&quotationSnapshotId=' + quotationSnapshotId +'&cardVendor='+ cardVendor +'&orderId='+ orderId;
        return this.makeGetCall(resourceURL);
    }

    getEncashmentFormWithOrderId(orderId) {
        var resourceURL = 'getEncashmentForm?&orderId='+ orderId;
        return this.makeGetCall(resourceURL);
    }    

    linkCard(request){
        var resourceUrl = "b2c/validateCustomer";
        return this.makePostCall(resourceUrl, request);
        
    }
     
    getAllOrderLrsDetails() {
        var resourceURL = 'getAllOrderLrsDetails';
        return this.makeGetCall(resourceURL);
    }

    lrsDeclaration(request){
        var resourceUrl = "lrsDeclaration";
        return this.makePostCall(resourceUrl, request);
    }



    //Student Pay Card API

    getAllCardDetail() {
        var resourceUrl = "gp/b2c/getCardsByMobile";
        return this.makeGetCall(resourceUrl);
    }

    getFullCardDetailWithCvv(kitId) {
        var resourceUrl = "gp/b2c/getFullCardWithCvv?kitId="+kitId;
        return this.makeGetCall(resourceUrl);
    }

    getCardBalance(kitId) {
        var resourceUrl = "gp/b2c/getBalance?kitId="+kitId;
        return this.makeGetCall(resourceUrl);
    }    

    //Manage Card API

    getStudentPayCardManageCardOption(kitId) {
        var resourceUrl = "gp/b2c/getPreferences?kitId="+kitId;
        return this.makeGetCall(resourceUrl);
    }

    updateStudentPayCardManageCardOption(requestBody) {
        var resourceUrl = "gp/b2c/updateCardPreference";
        return this.makePostCall(resourceUrl, requestBody);
    }    

    studentPayUpdatePin(requestBody) {
        var resourceUrl = "gp/b2c/updatePin";
        return this.makePostCall(resourceUrl, requestBody);
    }

    studentPayLockUnlockAndBlockCard(requestBody) {
        var resourceUrl = "gp/b2c/lockUnlockAndBlockCard";
        return this.makePostCall(resourceUrl, requestBody);
    }

    getStudentCardLimit(kitId) {
        var resourceUrl = "gp/b2c/getPreferences?kitId="+kitId;
        return this.makeGetCall(resourceUrl);
    }

    updateStudentCardLimit(requestBody) {
        var resourceUrl = "gp/b2c/updateCardLimit";
        return this.makePostCall(resourceUrl, requestBody);
    }    

    changeStudentCardPin(request) {
        var resourceUrl = "gp/b2c/updatePin";
        return this.makePostCall(resourceUrl, request);
    }

    verifyKit(request) {
        var resourceUrl = "gp/b2c/verifyKit";
        return this.makePostCall(resourceUrl, request);
    }

    sendOtpForLinkCard(request) {
        var resourceUrl = "gp/b2c/otpForLinkCard";
        return this.makePostCall(resourceUrl, request);
    }

    verifyOtpForLinkCard(request) {
        var resourceUrl = "gp/b2c/verifyOtpForLinkCard";
        return this.makePostCall(resourceUrl, request);
    }    

    requestForForexCard(request) {
        var resourceUrl = "wsfx/contactUs";
        return this.makePostCall(resourceUrl, request);
    }        


    /* Esim */

    esimPackages(countryCode) {
        var resourceUrl = "zetexaPackageSelection?country_code="+countryCode;
        return this.makeGetCall(resourceUrl);
    }

    buyEsimPackage(requestObj) {
        var resourceUrl = "buyZetexaPackageSelection";
        return this.makePostCall(resourceUrl, requestObj);
    }

    studentFetchStatement(startDate, endDate,isSendEmail,kitId,currencyCode, isFilter) {
        var resourceUrl = "";
        if(isFilter) {
            resourceUrl = 'gp/b2c/getStatement?fromDate=' + startDate + '&toDate=' + endDate+"&pageNo=0"+ '&sendEmail='+isSendEmail+'&kitId='+kitId + (currencyCode != 'All Currencies' ? '&currencyCode='+currencyCode : '');
        } else {
            resourceUrl = 'gp/b2c/getStatement?sendEmail='+isSendEmail+'&kitId='+kitId + (currencyCode != 'All Currencies' ? '&currencyCode='+currencyCode : '');
        }

        return this.makeGetCall(resourceUrl);
    }

    getLoungeAccessList(city) {
        var resourceUrl = 'getLoungeAccessListByCity?city=' + city;
        return this.makeGetCall(resourceUrl);
    }    

    getLoungeAccess(reqObj, kitId) {
        var resourceUrl = 'getLoungeAccess?kit='+kitId;
        return this.makePostCall(resourceUrl,reqObj);
    }

    udpateStudentCardFavCurrency(reqestObj) {
        var resourceUrl = 'gp/b2c/favouriteCurrencyCode';
        return this.makePostCall(resourceUrl,reqestObj);
    }

    placeLoungeAccessOrder(outletId) {
        var resourceUrl = 'placeLoungeAccessOrder?loungeId='+outletId;
        return this.makePostCall(resourceUrl,{});
    }    

    callPaymentGatewayForLounge(orderId, bankId) {
        var resourceUrl = "b2c/getPaymentGatewayLink?refOrderId="+orderId+"&bankId="+bankId+"&orderType=LOUNGE_ACCESS&isPartial=false";
       return this.makeGetCall(resourceUrl);
    }

    findPlanForESIM(countryId, days) {
        var resourceURL = "zx/getPackageByCountry?countryCode="+countryId+"&days="+days;
        return this.makeGetCall(resourceURL);
    }

    placeOrderForEsim(requestObj) {
        var resourceURL = "zx/placeOrder";
        return this.makePostCall(resourceURL,requestObj);
    }

    updateSimType(orderId, simType) {
        var resourceUrl = "zx/updateSimType?orderId="+orderId+"&simType="+simType;
        return this.makePostCall(resourceUrl, {});
    }

    callPaymentGatewayForEsim(orderId, bankId) {
        var resourceUrl = "b2c/getPaymentGatewayLink?refOrderId="+orderId+"&bankId="+bankId+"&orderType=E_SIM&isPartial=false";
       return this.makeGetCall(resourceUrl);
   }
    
    getLoungeAccessCities() {
        var resourceUrl = "getLoungeAccessCities";
       return this.makeGetCall(resourceUrl);
   }    

    explorersRegistration(request) {
        var resourceUrl = "explorersRegistration";
        return this.makePostCall(resourceUrl, request);
    }        

    explorersActivation(request) {
        var resourceUrl = "explorersActivation";
        return this.makePostCall(resourceUrl, request);
   }   
   
    getExplorersStatus(mobileNo) {
        var resourceUrl = "explorersStatus?mobile="+mobileNo;
       return this.makeGetCall(resourceUrl);
   }      


    getWalletTransferRate(requestObject) {
        var resourceUrl = 'gp/b2c/getWalletTransferRate';
        return this.makePostCall(resourceUrl, requestObject);
    }

    walletToWalletOtpOption(requestObject) {
        var resourceUrl = 'gp/b2c/walletTransferOtpOptions';
        return this.makePostCall(resourceUrl, requestObject);
    }    

    walletTransferOtp(request) {
        var resourceUrl = "gp/b2c/walletTransferOtp";
        return this.makePostCall(resourceUrl, request);
    }    

    walletTransfer(request, headerObj) {
        var resourceUrl = "gp/b2c/walletTransfer";
        return this.makePostCallWithExtraHeader(resourceUrl, request, headerObj);//
    }    

    switchCard(request) {
        var resourceUrl = "gp/b2c/switchCard";
        return this.makePostCall(resourceUrl, request);//
    }
    cashoutEsignOrder(request) {
        var resourceUrl = "order/esignCashOutOrder";
        return this.makePostCall(resourceUrl, request);//
    }    

    updateXplorerCustomerDetails(requestObject) {
        var resourceUrl = "xplorerCard/updateCustomerDetails";
        return this.makePutCall(resourceUrl, requestObject);
    }

    getXplorerCardQuote() {    
        var resourceUrl = "xplorerCard/buyXplorerCardKit";
        return this.makePostCall(resourceUrl, {});
    }


}